// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:43:49

export default {
  "id": "bank-robbery-3",
  "slug": "bank-robbery-3",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/68cfbb1a27534d8ab6fea9c0183dfae2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/68cfbb1a27534d8ab6fea9c0183dfae2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bank Robbery 3",
      "description": "It is time for a new robbery!\nYour new target is the most secure bank in the city.\nAccording to the inside data, the bank is equipped with the newest automated anti-robbery technologies, which makes this robbery a tough one.\nBut it shouldn’t be much of a problem for a professional like you.\nAnd as always, if you succeed, a big payday awaits you.\nCome on, let’s do it!",
      "instructions": "WASD = move\nLeft-click = shoot\nRight-click = iron sight\nMouse wheel / 1-7 = change weapons\nLeft-shift = run\nC = crouch\nE = interact",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "3d",
        "bomb",
        "guns",
        "police",
        "robber"
      ]
    },
    "zh-CN": {
      "title": "银行抢劫3",
      "description": "是时候进行一次新的抢劫了！\n你的新目标是城市中最为安全的银行。\n根据内部数据，这家银行配备了最新的自动防盗技术，这使得这次抢劫变得相当困难。\n但对于像你这样的专业人士来说，这不应该是个大问题。\n而且，一如既往的，如果你成功，丰厚的回报就在眼前。\n来吧，让我们行动起来！",
      "instructions": "WASD = 移动\n左键点击 = 射击\n右键点击 = 瞄准\n鼠标滚轮/1-7 = 切换武器\n左Shift = 跑步\nC = 蹲下\nE = 互动",
      "genres": [
        "射击类游戏"
      ],
      "tags": [
        "三维",
        "炸弹",
        "枪械",
        "警察",
        "劫匪"
      ]
    },
    "zh-TW": {
      "title": "銀行搶案3",
      "description": "是時候進行新的搶劫了！\n你的新目標是城裡最安全的銀行。\n根據內部資料，該銀行裝備了最新的自動化防搶技術，使得這次搶劫變得相當困難。\n但對於像你這樣的專業人士來說，應該不會是什麼大問題。\n而且，像往常一樣，如果你成功，等待你的將是一筆可觀的收入。\n來吧，我們動手吧！",
      "instructions": "WASD = 移動\n左鍵點擊 = 射擊\n右鍵點擊 = 瞄準鏡\n滑鼠輪 / 1-7 = 切換武器\n左 Shift = 跑步\nC = 蹲下\nE = 互動",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "3D",
        "炸彈",
        "槍枝",
        "警察",
        "強盜"
      ]
    },
    "zh-HK": {
      "title": "銀行搶掠3",
      "description": "是時候進行新的搶劫了！\n你的新目標是城中最安全的銀行。\n根據內部資料，該銀行裝備了最新自動化的防搶技術，使得這次搶劫變得相當困難。\n但對於像你這樣的專業人士來說，這不應該是什麼大問題。\n而且，一如既往，如果你成功，將會有一筆可觀的報酬在等待著你。\n來吧，我們去做吧！",
      "instructions": "WASD = 移動\n左鍵 = 射擊\n右鍵 = 鐵鏡\n滑鼠輪 / 1-7 = 更換武器\n左Shift = 跑步\nC = 蹲下\nE = 互動",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "3D",
        "炸彈",
        "槍械",
        "警察",
        "搶匪"
      ]
    },
    "ja": {
      "title": "銀行強盗3",
      "description": "新しい強盗の時間が来た！\nあなたの新しいターゲットは市内で最も安全な銀行です。\n内部情報によると、銀行は最新の自動防犯技術を装備しており、この強盗は難しいものになります。\nしかし、あなたのようなプロにとってはそれほど問題ではないでしょう。\nいつものように、成功すれば大きな報酬が待っています。\n行こう、やっちまえ！",
      "instructions": "WASD = 移動\n左クリック = 射撃\n右クリック = 望遠鏡\nマウスホイール / 1-7 = 武器切換\n左Shift = 走る\nC = 伏せる\nE = 交互作用",
      "genres": [
        "射撃ゲーム"
      ],
      "tags": [
        "3D",
        "爆弾",
        "銃",
        "警察",
        "強盗"
      ]
    },
    "ko": {
      "title": "은행 강도 3",
      "description": "새로운 강도 시간이 되었습니다!\n당신의 새로운 목표는 도시에서 가장 안전한 은행입니다.\n안내 데이터에 따르면, 은행은 최신 자동 강도 방지 기술을 장착하고 있어 이 강도는 어려운 일입니다.\n하지만 당신과 같은 전문가에게는 큰 문제가 되지 않을 것입니다.\n그리고 항상처럼, 성공하면 큰 보상이 기다리고 있습니다.\n와, 시작해보세요!",
      "instructions": "WASD = 이동\n왼쪽 클릭 = 발사\n오른쪽 클릭 = iron sight\n마우스 휠 / 1-7 = 무기를 변경\n왼쪽 Shift = 달리기\nC = 숨기기\nE = 상호작용",
      "genres": [
        "슈터"
      ],
      "tags": [
        "3D",
        "지뢰",
        "총",
        "경찰",
        "강도"
      ]
    },
    "fr": {
      "title": "Vol de banque 3",
      "description": "Il est temps pour une nouvelle cambriole !\nVotre nouvelle cible est la banque la plus sécurisée de la ville.\nSelon les informations internes, la banque est équipée des technologies automatisées de détection de cambriolage les plus récentes, ce qui rend cette cambriole particulièrement difficile.\nMais cela ne devrait pas poser de problème pour un professionnel comme vous.\nEt comme toujours, si vous réussissez, un gain substantiel vous attend.\nAllons-y, faisons-le !",
      "instructions": "WASD = déplacement\nClic gauche = tirer\nClic droit = viseur\nRoue de la souris / 1-7 = changer d'armes\nShift gauche = courir\nC = se baisser\nE = interagir",
      "genres": [
        "Tirailleur d'élite"
      ],
      "tags": [
        "3D",
        "bombe",
        "armes",
        "police",
        "cambrioleur"
      ]
    }
  }
};
